import React from "react";
import PropTypes from "prop-types";
import { Slot } from "react-page-layout";
import { Helmet } from "react-helmet";
import { Footer, Container, Row, Col, Card, CardBody, CardTitle } from "@components";
import Header from "@modules/account/components/header";
import { ToastContainer } from "react-toastify";
import config from "@config";
import "./login-layout.style.scss";

const LoginLayout = props => (
  <div className="page page-login">
    <Helmet>
      <meta charSet="utf-8" />
      <title>{props.title}</title>
    </Helmet>
    <Container fluid={true} className="py-5">
      <Row>
        <Col sm={{ size: 8, offset: 2 }}>
          <Card className="round-big shadow mt-5 py-3">
            <CardBody className="pb-0">
              <CardTitle>
                <Header />
              </CardTitle>
              <Row>
                <Col md="6">
                  <Slot name="left-column" className="left-shadow pt-4" />
                </Col>
                <Col md="6">
                  <Slot name="right-column" className="py-2" />
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Footer
            image1={"/assets/img/footer1.jpg"}
            image2={"/assets/img/footer2.jpg"}
            image3={"/assets/img/footer3.jpg"}
          />
        </Col>
      </Row>
    </Container>
    <ToastContainer
      position="bottom-left"
      type="default"
      autoClose={config.toasterShowTime}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      pauseOnHover
    />
  </div>
);

LoginLayout.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

LoginLayout.defaultProps = {
  title: "GoodShapeCentral!",
};

export default LoginLayout;
